module.exports = __webpack_public_path__ + "static/media/mm.fd2aa038.svg";